"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcOpStatus = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const OpStatus_1 = __importDefault(require("../OpStatus"));
function calcOpStatus(op) {
    if (!op)
        return;
    const isStarted = !!op.actualStart;
    const isCompleted = !!op.actualComplete;
    const actualComplete = (0, moment_timezone_1.default)(op.actualComplete);
    // Awaiting Approval
    if (op.awaitingApproval)
        return OpStatus_1.default.PENDING;
    // Completed on Time (No COMPLETE BY DATA)
    if (isCompleted && !op.completeBy)
        return OpStatus_1.default.COMPLETED;
    // Completed on Time - hoping that the start time is after the unix epoch
    if (isCompleted && actualComplete.isBetween((0, moment_timezone_1.default)(0), op.completeBy, undefined, '[]'))
        return OpStatus_1.default.COMPLETED;
    // Completed Late
    if (isCompleted && actualComplete.isAfter(op.completeBy))
        return OpStatus_1.default.COMPLETED_LATE;
    // Not Due
    if ((0, moment_timezone_1.default)().isBefore(op.startFrom))
        return OpStatus_1.default.NOT_DUE;
    // Closed
    if (op.closedDate && (0, moment_timezone_1.default)(op.closedDate).isValid())
        return OpStatus_1.default.MISSED;
    // Due
    if ((0, moment_timezone_1.default)().isBetween(op.startFrom, op.completeBy, undefined, '[]'))
        return isStarted ? OpStatus_1.default.STARTED : OpStatus_1.default.DUE;
    // Missed
    if (!op.isAdhoc && (0, moment_timezone_1.default)().isAfter((0, moment_timezone_1.default)(op.missedDeadlineDate)))
        return OpStatus_1.default.MISSED;
    if (op.isAdhoc)
        return isStarted
            ? isCompleted
                ? OpStatus_1.default.COMPLETED
                : OpStatus_1.default.OVERDUE_STARTED
            : OpStatus_1.default.OVERDUE_NOTSTARTED;
    // Overdue
    return isStarted ? OpStatus_1.default.OVERDUE_STARTED : OpStatus_1.default.OVERDUE_NOTSTARTED;
}
exports.calcOpStatus = calcOpStatus;
exports.default = calcOpStatus;
